var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1761 5.80241C13.1761 7.77973 11.5732 9.38266 9.59587 9.38266C7.61856 9.38266 6.01562 7.77973 6.01562 5.80241C6.01562 3.8251 7.61856 2.22217 9.59587 2.22217C11.5732 2.22217 13.1761 3.8251 13.1761 5.80241Z",
    stroke: "#757575",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3876 12.0679H7.80734C5.3357 12.0679 3.33203 14.0716 3.33203 16.5432C3.33203 17.5319 4.1335 18.3333 5.12215 18.3333H14.0728C15.0615 18.3333 15.8629 17.5319 15.8629 16.5432C15.8629 14.0716 13.8592 12.0679 11.3876 12.0679Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountName);
export default __webpack_public_path__ + "static/media/account-name.9ad9fd72e10cbf605cb4c26d8313cecc.svg";
export { ForwardRef as ReactComponent };